import { DbRef } from "./firebase";
import { SupplyInstructionOptions } from "./supply";
/** @deprecated */
export var ItineraryOfferStatus;
(function (ItineraryOfferStatus) {
    ItineraryOfferStatus["ACCEPTED"] = "accepted";
    ItineraryOfferStatus["DECLINED"] = "declined";
    ItineraryOfferStatus["NO_RESPONSE"] = "noResponse";
})(ItineraryOfferStatus || (ItineraryOfferStatus = {}));
export var WaypointType;
(function (WaypointType) {
    WaypointType["PICK_DROP"] = "pickDrop";
    WaypointType["PATIENT"] = "patient";
})(WaypointType || (WaypointType = {}));
export var WaypointStatusName;
(function (WaypointStatusName) {
    /**
     * Added to a `draft` itinerary
     * This is not relevant to a waypoint’s relationship with a `DraftWaypoint`
     */
    WaypointStatusName["DRAFT"] = "draft";
    WaypointStatusName["CREATED"] = "created";
    WaypointStatusName["IN_ITINERARY"] = "inItinerary";
    WaypointStatusName["TRANSIT_WAYPOINT"] = "transitWaypoint";
    WaypointStatusName["AT_WAYPOINT"] = "atWaypoint";
    WaypointStatusName["COMPLETE"] = "complete";
})(WaypointStatusName || (WaypointStatusName = {}));
/**
 * Order that waypoint statuses should sequentially update.
 * Changing the waypoint status to a previous value is not
 * allowed and will be enforced on the front end.
 *
 * Stored as an object to allow multiple statuses to contain
 * the same order index and enforce any new waypoint status
 * is included in the record
 */
export const WaypointStatusFulfillmentOrder = {
    [WaypointStatusName.DRAFT]: 0,
    [WaypointStatusName.CREATED]: 1,
    [WaypointStatusName.IN_ITINERARY]: 2,
    [WaypointStatusName.TRANSIT_WAYPOINT]: 3,
    [WaypointStatusName.AT_WAYPOINT]: 4,
    [WaypointStatusName.COMPLETE]: 5,
};
/**
 * Nurse waypoint transit status.
 * Used on the nurse app to display warning message depending on the transit status.
 */
export var WaypointTransitStatus;
(function (WaypointTransitStatus) {
    /** The waypoint transit starts in +120min */
    WaypointTransitStatus["TOO_EARLY"] = "tooEarly";
    /** The waypoint transit starts in 120-20 min */
    WaypointTransitStatus["EARLY"] = "early";
    /** The waypoint transit started 0-29min ago */
    WaypointTransitStatus["LATE"] = "late";
    /** The waypoint transit started +30min ago */
    WaypointTransitStatus["TOO_LATE"] = "tooLate";
})(WaypointTransitStatus || (WaypointTransitStatus = {}));
export var WaypointArrivalDelayReason;
(function (WaypointArrivalDelayReason) {
    WaypointArrivalDelayReason["ISSUES_WITH_DRIVING_INSTRUCTIONS"] = "issuesWithDrivingInstructions";
    WaypointArrivalDelayReason["LACK_OF_SIGNAL"] = "lackOfSignal";
    WaypointArrivalDelayReason["LEFT_TOO_LATE"] = "leftTooLate";
    WaypointArrivalDelayReason["OTHER"] = "other";
    WaypointArrivalDelayReason["PARKING_ISSUES"] = "parkingIssues";
    WaypointArrivalDelayReason["TECH_ISSUES"] = "techIssues";
    WaypointArrivalDelayReason["UNABLE_TO_ACCESS_LOCATION"] = "unableToAccessLocation";
})(WaypointArrivalDelayReason || (WaypointArrivalDelayReason = {}));
export var WaypointRunningLateReason;
(function (WaypointRunningLateReason) {
    WaypointRunningLateReason["DELAY_IN_MY_SCHEDULE"] = "delayInMySchedule";
    WaypointRunningLateReason["LEFT_TOO_LATE"] = "leftTooLate";
    WaypointRunningLateReason["OTHER"] = "other";
    WaypointRunningLateReason["TRAFFIC"] = "traffic";
    WaypointRunningLateReason["UNCLEAR_IN_APP_INSTRUCTIONS"] = "unclearInAppInstructions";
})(WaypointRunningLateReason || (WaypointRunningLateReason = {}));
export const WaypointRelationshipKeys = {
    draftWaypoints: { ref: DbRef.DRAFT_WAYPOINTS },
    itineraryID: { ref: DbRef.ITINERARIES },
    mailInWaypointActionID: { ref: DbRef.WAYPOINT_ACTIONS },
    placeID: { ref: DbRef.PLACES },
    processingActions: { ref: DbRef.WAYPOINT_ACTIONS },
    supplyItem: { ref: DbRef.SUPPLY_ITEMS },
    waypointActions: { ref: DbRef.WAYPOINT_ACTIONS },
};
export var WaypointActionType;
(function (WaypointActionType) {
    WaypointActionType["DROPOFF"] = "dropoff";
    WaypointActionType["MAIL_IN"] = "mailIn";
    WaypointActionType["PATIENT_ACTION"] = "patientAction";
    WaypointActionType["PICKUP"] = "pickup";
    /** ProcessingActionType */
    WaypointActionType["SAMPLE"] = "sample";
})(WaypointActionType || (WaypointActionType = {}));
export var WaypointActionStatusName;
(function (WaypointActionStatusName) {
    WaypointActionStatusName["DRAFT"] = "draft";
    WaypointActionStatusName["INCOMPLETE"] = "incomplete";
    WaypointActionStatusName["IN_PROGRESS"] = "inProgress";
    /**
     * All shipments on the mail-in action have been packed via the packing flow,
     * and the nurse is allowed to complete the mail-in steps.
     */
    WaypointActionStatusName["PACKED"] = "packed";
    /**
     * In the case of mail in waypoint actions, this means the package has been
     * sent to the destination lab
     */
    WaypointActionStatusName["COMPLETE"] = "complete";
    WaypointActionStatusName["CANCELED"] = "canceled";
})(WaypointActionStatusName || (WaypointActionStatusName = {}));
export const WaypointActionRelationshipKeys = {
    itineraryID: { ref: DbRef.ITINERARIES },
    mailInWaypointID: { ref: DbRef.WAYPOINTS },
    prerequisiteActions: { ref: DbRef.WAYPOINT_ACTIONS },
    placeGroupID: { ref: DbRef.PLACE_GROUPS },
    procedures: { ref: DbRef.PROCEDURES },
    shipments: { ref: DbRef.SHIPMENTS },
    waypointID: { ref: DbRef.WAYPOINTS },
};
export var ItineraryStatus;
(function (ItineraryStatus) {
    ItineraryStatus["DRAFT"] = "draft";
    ItineraryStatus["CREATED"] = "created";
    ItineraryStatus["ACCEPTED"] = "accepted";
    ItineraryStatus["IN_PROGRESS"] = "inProgress";
    ItineraryStatus["COMPLETED"] = "completed";
    ItineraryStatus["CANCELED"] = "canceled";
})(ItineraryStatus || (ItineraryStatus = {}));
export var ItineraryEditorStatus;
(function (ItineraryEditorStatus) {
    ItineraryEditorStatus["ONLINE"] = "online";
    ItineraryEditorStatus["OFFLINE"] = "offline";
})(ItineraryEditorStatus || (ItineraryEditorStatus = {}));
export const ItineraryRelationshipKeys = {
    nurseID: { ref: DbRef.USERS },
    shiftID: { ref: DbRef.SHIFTS },
    supplyTransfers: { ref: DbRef.SUPPLY_TRANSFERS },
    waypoints: { ref: DbRef.WAYPOINTS },
};
export const supplyInstructionsRequireProcessing = [
    SupplyInstructionOptions.CENTRIFUGE,
];
/** May consider supporting additional modals in the future. */
export var WaypointDeviationName;
(function (WaypointDeviationName) {
    WaypointDeviationName["DURATION"] = "duration";
    WaypointDeviationName["LOCATION"] = "location";
})(WaypointDeviationName || (WaypointDeviationName = {}));
export var LocationComplianceDeviationReason;
(function (LocationComplianceDeviationReason) {
    LocationComplianceDeviationReason["NO_AVAILABLE_PARKING"] = "noAvailableParking";
    LocationComplianceDeviationReason["INCORRECT_ADDRESS"] = "incorrectAddress";
    LocationComplianceDeviationReason["UNCLEAR_INSTRUCTIONS"] = "unclearInstructions";
})(LocationComplianceDeviationReason || (LocationComplianceDeviationReason = {}));
export var DurationComplianceDeviationReason;
(function (DurationComplianceDeviationReason) {
    DurationComplianceDeviationReason["THIS_IS_HOW_LONG_I_WOULD_EXPECT_THE_WAYPOINT_TO_LAST"] = "thisIsHowLongIWouldExpectTheWaypointToLast";
    DurationComplianceDeviationReason["LOCATION_ACCESS_ISSUES"] = "locationAccessIssues";
    DurationComplianceDeviationReason["PARKING_DISTANCE_FROM_WAYPOINT"] = "parkingDistanceFromWaypoint";
    DurationComplianceDeviationReason["PREPARATION_TOOK_TIME"] = "preparationTookTime";
    DurationComplianceDeviationReason["I_HAD_TO_WAIT_AT_THIS_WAYPOINT"] = "iHadToWaitAtThisWaypoint";
    DurationComplianceDeviationReason["TECH_ISSUE"] = "techIssue";
    DurationComplianceDeviationReason["OTHER"] = "other";
})(DurationComplianceDeviationReason || (DurationComplianceDeviationReason = {}));
//# sourceMappingURL=waypoint.js.map